import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

export const listPartSourceQuery = () => {
  return queryOptions({
    queryKey: ["part-sources", "list"],
    queryFn: async (): Promise<PowerUpServiceResponseBody["listPartSource"][200]> =>
      handleClientMethod(
        getClient().GET("/part-sources"),
      ),
  });
};
